/** @jsxImportSource @emotion/react */
import { StyleSheet, View } from "@react-pdf/renderer";
import PDFContainerDefects from "../PDFContainerDefects";

const styles = StyleSheet.create({
    row2: {
        flexDirection: "row",
        justifyContent: "space-between",
        flexGrow: 1,
    },
});

export const PDFDefectGroups = ({ defectGroups, checks, allDefects }) => (
    <View style={styles.row2} wrap={false}>
        {defectGroups.map((group, index) => (
            <PDFContainerDefects
                key={index}
                tenantDefectDefinitions={allDefects}
                defect_group={group}
                printChecks={checks}
            />
        ))}
    </View>
);
